<template>
  <div>
    <v-row v-if="!isProfileFilled">
      <v-col cols="12">
        <v-alert type="error" dense>
          <router-link :to="{ name: 'profile_info' }" class="white--text fw-bold underline">
            {{ empty_profile_text }}
          </router-link>
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-else>
      <domain-transfer />
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            Domain Transfer FAQ
          </gg-card-header>
          <gg-card-text>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Question #1 Accepted Domains & Pricing</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <first-question/>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>Question #2 Domain Transfer Instructions</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <second-question/>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>Question #3 New ICANN Rules For Domain Names Starting January 1, 2014</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <third-question/>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DomainTransfer from '@/components/Domains/DomainTransfer'
import FirstQuestion from './TranferFAQ/FirstQuestion'
import SecondQuestion from './TranferFAQ/SecondQuestion'
import ThirdQuestion from './TranferFAQ/ThirdQuestion'
import { isProfileFilled } from 'Helpers/helpers'

export default {
  name: 'DomainTransferView',
  data: () => ({
    empty_profile_text: 'You must complete your profile before you can transfer a domain.'
  }),
  components: {
    DomainTransfer, FirstQuestion, SecondQuestion, ThirdQuestion
  },
  computed: {
    isProfileFilled
  }
}
</script>
